module.exports = __webpack_public_path__ + "542bab716fc6df810d2585eed97f0064.svg";